import { Component, OnInit, Input } from '@angular/core'
import * as moment from 'moment'

@Component({
	selector: 'app-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

	@Input() data: Array<any> = []
	@Input() head: Array<any> = []
	@Input() sort: string
	@Input() order: number = 1
	@Input() searchbar: boolean = true

	needle: string = ''
	_data: Array<any> = []
	_sort: string
	_order: number = 1

	constructor() {}

	ngOnInit() {
		this._sort = this.sort || this.head.filter(a => a.sort !== false)[0].key
		this._order = this.order || 1
	}

	ngOnChanges() {
		this.search(null)
	}

	sortOn(field) {
		if (this._sort == field)
			this._order *= -1
		else
			this._sort = field
		this.sortData()
	}

	search(event) {
		this.needle = event && event.target ? event.target.value : this.needle
		this._data = this.data.filter(item => {
			for (let j in this.head) {
				let field = this.head[j]
				if (!field.type && item[field.key] && item[field.key].match(new RegExp((this.needle.length > 2 ? this.needle : ''), "i")))
					return true
			}
			return false
		})
		this.sortData()
	}

	sortData() {
		this._data.sort((a, b) => {
			return String(a[this._sort]).localeCompare(String(b[this._sort])) * this._order
		})
	}

	moment(timestamp: string) {
		if (!timestamp) return ''
		// return moment(timestamp).fromNow().replace('a few seconds ago', 'a minute ago')
		return moment(timestamp).calendar()
	}

	momenttitle(timestamp: string) {
		if (!timestamp) return ''
		// return moment(timestamp).calendar()
		return moment(timestamp).format('MMMM Do YYYY, h:mm:ss a')
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/table/table.component.ts